export default __webpack_public_path__ + "static/raisefund_bg-43d58629c2b8192bb197e046e94c863a.png";